import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useState, useMemo } from "react";
import { DateTime } from "luxon";
import InfiniteCalendar, { withRange, Calendar, EVENT_TYPE, } from "react-infinite-calendar";
import DatePickerMobileModal from "../DatePickerMobileModal";
import getDateFnsLocale from "../../utils/functions/dateFns";
const CalendarWithRange = withRange(Calendar);
const DateRangePickerMobile = forwardRef(({ mobileTitleLabel, mobileSubTitleLabel, value, placeholder = "Check-in/Check-out", confirmDateLabel, resetDateLabel, localeLang, localeMobileConfig, formatDateOptions, minDate, maxDate, minimumDays, disabledDays, disabledDates, onReset, onClose, onConfirm, }, ref) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const [dateCountSelected, setDateCountSelected] = useState(0);
    const [currentDates, setCurrentDates] = useState(value
        ? [(_b = (_a = value === null || value === void 0 ? void 0 : value[0]) === null || _a === void 0 ? void 0 : _a.toJSDate()) !== null && _b !== void 0 ? _b : undefined, (_d = (_c = value === null || value === void 0 ? void 0 : value[1]) === null || _c === void 0 ? void 0 : _c.toJSDate()) !== null && _d !== void 0 ? _d : undefined]
        : undefined);
    const [dates, setDates] = useState(value
        ? [(_f = (_e = value === null || value === void 0 ? void 0 : value[0]) === null || _e === void 0 ? void 0 : _e.toJSDate()) !== null && _f !== void 0 ? _f : undefined, (_h = (_g = value === null || value === void 0 ? void 0 : value[1]) === null || _g === void 0 ? void 0 : _g.toJSDate()) !== null && _h !== void 0 ? _h : undefined]
        : undefined);
    const [isOpen, setIsOpen] = useState(false);
    const localeConfig = useMemo(() => getDateFnsLocale(localeLang, localeMobileConfig), [localeLang, localeMobileConfig]);
    const handleOnReset = () => {
        setCurrentDates(undefined);
        setDateCountSelected(0);
        if (onReset) {
            onReset();
        }
    };
    const handleOnClose = () => {
        setCurrentDates(dates);
        if (onClose) {
            onClose();
        }
        setIsOpen(false);
    };
    const handleOnConfirm = () => {
        setDates(currentDates);
        if (onConfirm) {
            onConfirm(currentDates);
        }
        setIsOpen(false);
    };
    const handleOnSelect = ({ start, end, eventType }) => {
        if ([EVENT_TYPE.START, EVENT_TYPE.END].includes(eventType)) {
            if (dateCountSelected >= 2) {
                setDateCountSelected(1);
            }
            else {
                setDateCountSelected((curr) => curr + 1);
            }
        }
        setCurrentDates([start, end]);
        /* if (onCalendarChange) {
          const startDate = DateTime.fromJSDate(start);
          const endDate = DateTime.fromJSDate(end);
          onCalendarChange(
            [startDate, endDate],
            [startDate?.toLocaleString() ?? "", endDate?.toLocaleString() ?? ""],
          );
        } */
    };
    const getMinDate = () => {
        if (!!minimumDays && (currentDates === null || currentDates === void 0 ? void 0 : currentDates[0]))
            return DateTime.fromJSDate(currentDates[0]).plus({ days: minimumDays }).toJSDate();
        return minDate;
    };
    return (_jsx(DatePickerMobileModal, { value: currentDates, isOpen: isOpen, dateCountSelected: dateCountSelected, onDateClick: () => setIsOpen(true), onConfirm: handleOnConfirm, onReset: handleOnReset, onClose: handleOnClose, localeLang: localeLang, placeholder: placeholder, formatDateOptions: formatDateOptions, title: mobileTitleLabel, subTitle: mobileSubTitleLabel, confirmLabel: confirmDateLabel, resetLabel: resetDateLabel, children: _jsx(InfiniteCalendar, { ref: ref, Component: CalendarWithRange, selected: currentDates
                ? {
                    start: currentDates === null || currentDates === void 0 ? void 0 : currentDates[0],
                    end: (_j = currentDates === null || currentDates === void 0 ? void 0 : currentDates[1]) !== null && _j !== void 0 ? _j : currentDates === null || currentDates === void 0 ? void 0 : currentDates[0],
                }
                : false, width: window.innerWidth, height: window.innerHeight, onSelect: handleOnSelect, disabledDays: disabledDays, disabledDates: disabledDates, displayOptions: {
                showMonthsForYears: false,
            }, locale: localeConfig, minDate: getMinDate(), maxDate: maxDate }) }));
});
export default DateRangePickerMobile;
